import { render, staticRenderFns } from "./ManageModels.vue?vue&type=template&id=48264c66&scoped=true&"
import script from "./ManageModels.vue?vue&type=script&lang=js&"
export * from "./ManageModels.vue?vue&type=script&lang=js&"
import style0 from "./ManageModels.vue?vue&type=style&index=0&id=48264c66&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48264c66",
  null
  
)

export default component.exports